import React from 'react';
import { styled, StyledProps } from '@glitz/react';
import Image, { Ratio as ImageRatio } from 'Shared/Image/Ratio';
import { ErrorMessage } from 'Shared/FeedbackMessage';
import CartValidationItemType from 'Cart/Models/CartValidationItem.type';
import CheckoutLabels from 'Checkout/Pages/Checkout/CheckoutPageViewModel+CheckoutLabels.type';
import CartLabels from 'Cart/Models/MiniCartViewModel+CartLabels.type';
import Link from 'Shared/Generic/A';
import { Preset } from 'Shared/image-sizes';
import { TextBlock, ResponsiveSize } from 'Shared/SharedComponents/atoms/Typography';
import * as style from 'Shared/Style';

type PropType = StyledProps & {
  item: CartValidationItemType;
  labels: CheckoutLabels | CartLabels;
  isMobile: boolean;
};

const Base = styled.div({
  display: 'flex',
  backgroundColor: style.colors.monochrome.extraLightGrey,
  padding: {
    xy: 8,
  },
  borderRadius: 8,
  marginBottom: 12,
});

const Media = styled.div({
  flexBasis: '98px',
});

const ContentBase = styled.div({
  position: 'relative',
  fontSize: 14,
  flexGrow: 1,
  display: 'flex',
});

const ContentMobile = styled(ContentBase, {
  flexDirection: 'column',
  gap: '6px',
  marginLeft: '8px'
});

const ContentDesktop = styled(ContentBase, {
  margin: { xy: 8 },
});

const ItemDataDeskTopWrap = styled.div({
  display: 'flex',
  flexGrow: 1,
  flexDirection: 'column',
  gap: '14px',
})

const ItemDataContent = styled.div({
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
})

const SizeData = styled(TextBlock, {
  color: style.colors.monochrome.a11ygrey,
});

const CartItemLink = styled(Link, {
  display: 'block',
  textTransform: 'uppercase',
  fontWeight: 500,
  color: style.colors.monochrome.black,
  fontSize: '14px',
  lineHeight: '100%',
});

const Message = styled(ErrorMessage, {
  height: `calc(16px * 1.5)`,
});

const Item = (props: PropType) => {

  const ContentWrap = props.isMobile ? ContentMobile : ContentDesktop;

  const ItemData = (<>
    <ItemDataContent>
      <CartItemLink to={props.item.url}>
        {props.item.displayName}
      </CartItemLink>
      <TextBlock fontSize={ResponsiveSize.D14_M14_L130}>
        {props.item.oneLineText}
      </TextBlock>
      <SizeData fontSize={ResponsiveSize.D14_M14_L130}>
        {props.item.color}, {props.labels.size}: {props.item.size}
      </SizeData>
    </ItemDataContent>
  </>);

  return (
    <styled.Div css={props.compose()}>
      <Base>
        <Media>
          <Image
            src={{ url: props.item.imageUrl }}
            alt={props.item.displayName}
            ratio={ImageRatio.ThreeToFour}
            preset={Preset.ItemThumbLarge}
            borderRadius={8}
          />
        </Media>
        <ContentWrap>
          {!props.isMobile ? <ItemDataDeskTopWrap>
              {ItemData}
            </ItemDataDeskTopWrap> : {ItemData}}

            <Message>{props.item.message}</Message>
        </ContentWrap>
      </Base>
      
    </styled.Div>
  );
};

export default styled(Item, {
  marginBottom: '10px',
});
